/**
 * Преобразует коллекции из API в данные форм, не выполняя запросов.
 * Используется при редактировании связанных записей, а не для defaults создания.
 */
// Сохраняет null/undefined как «не менять», а [] как явную очистку.
export function mapAssociationList(records, mapper) {
  return records == null ? records : records.map(mapper);
}

// Даёт контролу массив для отображения, не записывая default обратно в форму.
export function associationListForControl(records) {
  return Array.isArray(records) ? records : [];
}

// Пользовательское добавление превращает неизвестное значение в явный список.
export function appendAssociationList(records, record) {
  return [...associationListForControl(records), record];
}

// Пользовательское удаление всегда возвращает явный список, включая [].
export function removeAssociationList(records, predicate) {
  return associationListForControl(records).filter(
    (record, index) => !predicate(record, index)
  );
}

// Пустой контрол не очищает неизвестный список, но сохраняет явное [] формы.
export function associationListAfterControlEdit(records, controlRecords) {
  if (records == null && controlRecords.length === 0) return records;

  return [...controlRecords];
}
